import { render, staticRenderFns } from "./account-su-updates-create.html?vue&type=template&id=1c9d5f92&scoped=true&"
import script from "./account-su-updates-create.js?vue&type=script&lang=js&"
export * from "./account-su-updates-create.js?vue&type=script&lang=js&"
import style0 from "./account-su-updates-create.scss?vue&type=style&index=0&id=1c9d5f92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9d5f92",
  null
  
)

export default component.exports